import { getAudioDurationInSeconds } from '@remotion/media-utils';
import { CalcMetadataReturnType } from 'remotion/dist/cjs/Composition';
import { FPS } from './audiogram/constants';
import { AudiogramProps } from './audiogram/schema';
import { getSubtitles } from './helpers';

export async function calculateAudiogramMetadata({
  props,
}: {
  props: Partial<AudiogramProps>;
}): Promise<CalcMetadataReturnType<AudiogramProps>> {
  const captions = props.captions?.length ? props.captions : await getSubtitles(props.captionsUrl!);
  const durationInSeconds = await getAudioDurationInSeconds(props.audioFileUrl!);

  return {
    durationInFrames: Math.floor((durationInSeconds - (props.audioOffsetInSeconds ?? 0)) * FPS),
    props: {
      ...props,
      captions,
    } as AudiogramProps,
    fps: FPS,
  };
}
